import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const processProviderManualOrder = (data) => apiActionCreator({
  'endpoint': '/orders/providers/manual',
  'authenticated': true,
  'types': [
    ActionTypes.PROCESS_PROVIDER_MANUAL_ORDER_REQUEST,
    [
      ActionTypes.PROCESS_PROVIDER_MANUAL_ORDER_SUCCESS,
      (response) => addMessageBoxInfo(`Pedido generado satisfactoriamente: ${response.data}`),
    ],
    [
      ActionTypes.PROCESS_PROVIDER_MANUAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const askForProviderManualOrderAuthorization = (data) => apiActionCreator({
  'endpoint': '/orders/providers/manual',
  'authenticated': true,
  'types': [
    ActionTypes.ASK_FOR_PROVIDER_MANUAL_ORDER_REQUEST,
    [
      ActionTypes.ASK_FOR_PROVIDER_MANUAL_ORDER_SUCCESS,
      addMessageBoxInfo('El pedido ha iniciado el flujo de autorización'),
    ],
    [
      ActionTypes.ASK_FOR_PROVIDER_MANUAL_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const restoreProviderManualOrder = () => ({
  'type': ActionTypes.RESTORE_PROVIDER_MANUAL_ORDER,
});

export const changeProviderManualOrderParameter = (field, value) => ({
  'type': ActionTypes.CHANGE_PROVIDER_MANUAL_ORDER_PARAMETER,
  'payload': {field, value},
});

export const changeProviderManualOrderAllParameter = (parameters) => ({
  'type': ActionTypes.CHANGE_PROVIDER_MANUAL_ORDER_ALL_PARAMETER,
  'payload': {parameters},
});

export const editProviderManualOrderElementCode = (index, value) => ({
  'type': ActionTypes.EDIT_PROVIDER_MANUAL_ORDER_ELEMENT_CODE,
  'payload': {index, value},
});

export const editProviderManualOrderElementQuantity = (index, value) => ({
  'type': ActionTypes.EDIT_PROVIDER_MANUAL_ORDER_ELEMENT_QUANTITY,
  'payload': {index, value},
});

export const addElementToProviderManualOrder = () => ({
  'type': ActionTypes.ADD_PROVIDER_MANUAL_ORDER_ELEMENT,
});

export const removeElementFromProviderManualOrder = (index) => ({
  'type': ActionTypes.REMOVE_PROVIDER_MANUAL_ORDER_ELEMENT,
  'payload': index,
});
